import { useState, useCallback } from 'react';
import adminApi from '../api/adminApi';
import { clearAdminAuth, getAdminUser, hasAdminAuth, setAdminAuth } from '../utils/authStorage';

export const useAdminAuth = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const login = useCallback(async (username, password) => {
    setLoading(true);
    setError(null);
    try {
      const { data } = await adminApi.post('/admin/login', { username, password });
      if (!data || typeof data !== 'object' || typeof data.token !== 'string' || !data.token) {
        throw new Error('Invalid login response');
      }
      setAdminAuth({ token: data.token, username: data.username, role: data.role });
      return data;
    } catch (err) {
      const msg = err.response?.data?.detail || err.message || 'Login failed';
      setError(msg);
      throw new Error(msg);
    } finally {
      setLoading(false);
    }
  }, []);

  const logout = useCallback(() => {
    clearAdminAuth();
    window.location.href = '/admin/login';
  }, []);

  const getUser = useCallback(() => {
    return getAdminUser();
  }, []);

  const isLoggedIn = useCallback(() => hasAdminAuth(), []);

  return { login, logout, getUser, isLoggedIn, loading, error };
};
